module.exports = __webpack_public_path__ + "img/footer-logo.b3ba4767.png";